import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AppsIcon from '@material-ui/icons/Apps';
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Avatar,
  Typography
} from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import logoImg from '../../../Assets/images/logo.jpg';
import { logout, useAuthDispatch, useAuthState } from '../../../Context';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Badge from '@material-ui/core/Badge';
import userImg from '../../../Assets/images/loading-waiting.gif';
import defaultImage from '../../../Assets/images/customer-default-logo.png';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { Paths, UserPath } from '../../../Routes/routePaths';
import EditIcon from '@material-ui/icons/Edit';
import { UserServices } from '../../../Services/UserServices';
import { useHistory, useLocation } from 'react-router';
import variables from '../../../Sys/variable.scss';
import { USER_ROLES } from '../../../utils/constants';
import DynamicAutoSearch from 'Components/DynamicAutoSearch';
import { CoursesServices } from 'Services/CoursesServices';
import { useContext } from 'react';
import { CourseContext } from 'Context/CourseProvider';
import { getEncodeURL } from 'utils';
import { useKeycloak } from "../../../Context/keyCloakProvider";
import { goToMoodleLogoutOrKeycloak } from '../../../utils/moodleSingleLogout';
const userServices = new UserServices();
const coursesService = new CoursesServices();

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 0,
    flexShrink: 0,
  },
  headerBar: {
    backgroundColor: variables.headerColor,
    height: 72,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    position: 'relative',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    [theme.breakpoints.down('sm')]: {
      height: 64,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    padding: theme.spacing(0, 3),
    boxSizing: 'border-box',
    minHeight: '72px !important',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      padding: theme.spacing(0, 2),
      minHeight: '64px !important',
    },
    '@media (max-width: 374px)': {
      padding: theme.spacing(0, 1),
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: variables.darkThemeText || '#fff',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      marginRight: theme.spacing(1),
    },
  },
  title: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      flexGrow: 0,
      marginRight: theme.spacing(1),
      flex: '0 0 auto',
    },
  },
  logo: {
    cursor: 'pointer',
    width: '100%',
    maxWidth: 140,
    height: 'auto',
    maxHeight: 48,
    objectFit: 'contain',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 100,
      maxHeight: 36,
    },
  },
  logoAdmin: {
    cursor: 'pointer',
    width: '100%',
    maxWidth: 140,
    height: 'auto',
    maxHeight: 48,
    objectFit: 'contain',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 100,
      maxHeight: 36,
    },
  },
  searchBar: {
    flexGrow: 1,
    marginLeft: theme.spacing(4),
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    '@media (max-width: 1024px)': {
      display: 'none',
    },
  },
  searchBarMobile: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: variables.headerColor,
      padding: theme.spacing(2),
      zIndex: 1000,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      borderTop: '1px solid rgba(0, 0, 0, 0.05)',
    },
  },
  searchIconButton: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: '0 0 auto',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  },
  exploreButton: {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
    padding: theme.spacing(1, 3),
    borderRadius: 8,
    transition: 'all 0.2s ease',
    border: '1px solid rgba(60, 125, 221, 0.3)',
    '&:hover': {
      backgroundColor: 'rgba(60, 125, 221, 0.08)',
      borderColor: 'rgba(60, 125, 221, 0.5)',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  exploreButtonMobile: {
    display: 'none',
    fontSize: '0.875rem',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flex: '0 0 auto',
      marginLeft: theme.spacing(0.5),
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileIconsGroup: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      marginLeft: 'auto',
      flex: '0 0 auto',
    },
  },
  iconBtn: {
    borderRadius: '50%',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 0',
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(0.5),
    },
  },
  profileImg: {
    width: 80,
    height: 80,
    margin: '0 auto',
    overflow: 'hidden',
    border: '2px solid rgba(0, 0, 0, 0.08)',
    borderRadius: '50%',
    backgroundColor: '#f5f5f5'
  },
  editBack: {
    position: 'absolute',
    width: 75,
    height: 26,
    bottom: 0,
    textAlign: 'center',
    paddingTop: 6,
    color: '#fff',
    background: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(4px)',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.7)',
    },
  },
  rightMenuItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navSectionLink: {
    fontWeight: 500,
    fontSize: '0.875rem',
    padding: theme.spacing(0.5, 1),
    cursor: 'pointer',
    transition: 'color 0.2s ease',
    color: variables.darkThemeText,
    textDecoration: 'none',
    '&:hover': {
      color: '#3C7DDD',
    },
  },
  navSectionLinkActive: {
    color: '#3C7DDD',
    '&:hover': {
      color: '#3C7DDD',
    },
  },
  mobileNavMenuItem: {
    fontSize: '0.875rem',
    fontWeight: 500,
    padding: theme.spacing(1.25, 2),
    borderRadius: 8,
    margin: theme.spacing(0.25, 1),
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(60, 125, 221, 0.08)',
    },
  },
  mobileNavMenuItemActive: {
    color: '#3C7DDD',
    backgroundColor: 'rgba(60, 125, 221, 0.12)',
    '&:hover': {
      backgroundColor: 'rgba(60, 125, 221, 0.18)',
    },
  },
  mobileMenuButton: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flex: '0 0 auto',
      marginLeft: theme.spacing(0.5),
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  },
  mobileMenuPaper: {
    marginTop: theme.spacing(1.5),
    minWidth: 200,
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(0.5),
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.5),
      marginLeft: 'auto',
      flex: '0 0 auto',
      justifyContent: 'flex-end',
    },
  },
  profileButton: {
    textTransform: 'none',
    fontWeight: 500,
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 8,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  profileButtonText: {
    marginRight: theme.spacing(0.5),
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem',
    },
  },
  menuContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto auto',
    backgroundColor: 'transparent',
    gap: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'auto auto auto',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'auto auto',
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'auto',
      gap: theme.spacing(1.5),
    },
  },
  menuContainerItem: {
    margin: 0,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      margin: 0,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      width: '100%',
    },
  },
  header: {
    fontSize: '0.875rem',
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    color: variables.darkThemeText,
    letterSpacing: '-0.01em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem',
      marginBottom: theme.spacing(1),
    },
  },
  menuSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.25),
    },
  },
  viewAll: {
    color: '#3C7DDD',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    '&:hover': {
      textDecoration: 'underline',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      padding: theme.spacing(0.5),
    },
  },
  lastRow: {
    gridColumn: 'span 4',
    justifySelf: 'end',
    [theme.breakpoints.down('lg')]: {
      gridColumn: 'span 3',
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 2',
      justifySelf: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      gridColumn: 'span 1',
      justifySelf: 'stretch',
      width: '100%',
    },
  },
  browseAll: {
    color: '#3C7DDD',
    background: 'white',
    cursor: 'pointer',
    padding: theme.spacing(1.5, 5),
    marginTop: theme.spacing(3),
    borderRadius: 8,
    fontWeight: 500,
    textTransform: 'none',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(60, 125, 221, 0.15)',
    '&:hover': {
      backgroundColor: '#f8f9fa',
      boxShadow: '0 4px 12px rgba(60, 125, 221, 0.2)',
      transform: 'translateY(-1px)',
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.25, 3.5),
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 3),
      marginTop: theme.spacing(1.5),
      width: '100%',
      fontSize: '0.875rem',
    },
  }
}));

export const TopBarButton = ({
  name,
  icon,
  layout,
  path,
  button = false,
  activeClassName = 'active'
}) => (
  <NavLink
    to={layout + path}
    activeClassName={activeClassName}
    exact
    id="topBar_nav">
    <Button
      color={button ? 'primary' : 'secondary'}
      variant={button ? 'contained' : 'default'}
      size="large"
      id="topBar_button">
      <span id="topBar_span">
        <i className={icon} />
      </span>
      <span> {name} </span>
    </Button>
  </NavLink>
);

const Header = ({ onMenuClick, showHamburger = false }) => {
  const { keycloak, setAuthenticated } = useKeycloak();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTinyScreen = useMediaQuery('(max-width:374px)');
  const history = useHistory();
  const location = useLocation();
  const isNavItemActive = (path) => {
    if (path === Paths.Dashboard) return location.pathname === Paths.Dashboard;
    if (path.includes('inprogress')) return location.pathname === UserPath.RegisteredCourses && location.search.includes('inprogress');
    if (path.includes('completed')) return location.pathname === UserPath.RegisteredCourses && location.search.includes('completed');
    return false;
  };
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const anchorRef = React.useRef(null);
  const avatarAnchorRef = React.useRef(null);
  const [logoUrl, setLogoUrl] = useState(
    localStorage.getItem('company_logo') &&
      localStorage.getItem('company_logo') !== 'null'
      ? localStorage.getItem('company_logo')
      : logoImg
  );
  const [searchCourses, setSearchCourses] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [optLoading, setOptLoading] = useState('not');
  const [otherImgWidth, setOtherImgWidth] = useState(0);
  const { courseCatalogues } = useContext(CourseContext);

  const dispatch = useAuthDispatch();
  const { userDetails } = useAuthState(dispatch);
  const menuRef = React.useRef(null);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const mobileMenuAnchorRef = React.useRef(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const menu_items = [
    { name: 'Dashboard', path: Paths.Dashboard },
    {
      name: 'In-progress',
      path: UserPath.RegisteredCourses + '?type=inprogress'
    },
    { name: 'Completed', path: UserPath.RegisteredCourses + '?type=completed' }
  ];
  const [loading, setLoading] = useState(true);
  const [courseCatalogueList, setCourseCatalogueList] = useState([]);
  const [userRole, setUserRole] = useState(USER_ROLES.USER);
  const [globalSearchVal, setGlobalSearchVal] = useState('');

  React.useEffect(() => {
    let courseList = courseCatalogues;
    if (courseList?.status) {
      setLoading(false);
      setCourseCatalogueList(courseList.data);
    }
  }, [courseCatalogues]);

  const handleToggleMenu = () => {
    setMenuOpen(prevOpen => !prevOpen);
  };

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const handleMobileMenuItemClick = (path) => {
    history.push(path);
    handleMobileMenuClose();
  };

  React.useEffect(() => {
    if (userDetails) {
      const getRole = localStorage.getItem('role').trim();
      getUserProfile();
      setUserRole(getRole || USER_ROLES.USER);
      if (window.location.hostname !== 'platform.deviare.africa') {
        setLogoUrl(localStorage.getItem("company_logo") !== 'null' ? localStorage.getItem("company_logo") : logoImg);
        setOtherImgWidth(85);
      }
    }
  }, [userDetails]);

  const getUserProfile = async () => {
    setProfileLoading(true);
    const user = await userServices.getDetailMyProfile();
    if (user && user.data && user.data.length) {
      setLoggedInUser(user.data[0]);
      localStorage.setItem('comp_ids', user.data[0].uuid);
    }
    setProfileLoading(false);
  };

  const handleLogout = async () => {
    setAuthenticated(false);
    await logout(dispatch);
    localStorage.clear();
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });
    goToMoodleLogoutOrKeycloak(keycloak);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    const currentAnchor = isMobile ? avatarAnchorRef.current : anchorRef.current;
    if (currentAnchor && currentAnchor.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleProfile = () => {
    history.push(Paths.Profile);
  };

  const handleChangePassword = () => {
    history.push(Paths.ChangePassword);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleGlobalSearch = async value => {
    setGlobalSearchVal(value);
  };

  React.useEffect(() => {
    if (!globalSearchVal) {
      setSearchCourses([]);
    } else {
      const getData = setTimeout(async () => {
        getSearchCourseList(globalSearchVal);
      }, 500);
      return () => clearTimeout(getData);
    }
  }, [globalSearchVal]);

  const getSearchCourseList = async searchVal => {
    setOptLoading('');
    const courseList = await coursesService.getEcommerceCourses(
      searchVal ? `name=${searchVal}` : ''
    );
    if (courseList.status && courseList.data) {
      const courses = [];
      courseList.data.forEach(itm => {
        itm.courses.forEach(cs => {
          if (courses.length < 11) {
            courses.push({ ...cs });
          }
        });
      });
      setSearchCourses(courses);
    }
    setOptLoading('not');
  };

  const handleSubManuClicked = itm => {
    setMenuOpen(false);
    history.push(
      itm
        ? getEncodeURL(`${UserPath.CourseCatalogue}?category=${itm.category}`)
        : UserPath.CourseCatalogue
    );
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.headerBar}>
        <Toolbar className={classes.toolbar}>
          {showHamburger && (
            <IconButton
              data-testid="hamburger-menu"
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={onMenuClick}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
          )}
          {userRole === USER_ROLES.USER ? (
            <>
              <div className={classes.title}>
                <img
                  className={classes.logo}
                  style={{
                    width: otherImgWidth || '100%',
                  }}
                  alt="Deviare"
                  onClick={() => history.push(Paths.Dashboard)}
                  src={logoUrl}
                />
              </div>

              <div className={classes.searchBar}>
                <DynamicAutoSearch
                  open={searchOpen}
                  handleChange={(evt, newVal) => {
                    window.location.href = `/skill-transformation/course-catalogue?category=${newVal.category}`;
                  }}
                  handleOpen={val => {
                    setSearchOpen(val);
                  }}
                  options={searchCourses}
                  handleSearch={handleGlobalSearch}
                  optLoading={optLoading}
                />
                {!isMobile && (
                  <Button
                    variant="outlined"
                    color="primary"
                    disabled={loading}
                    ref={menuRef}
                    aria-controls={menuOpen ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggleMenu}
                    className={classes.exploreButton}
                    endIcon={menuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}>
                    Explore
                  </Button>
                )}
              </div>

              {/* Mobile Search Icon - Next to Logo */}
              <IconButton
                className={classes.searchIconButton}
                onClick={() => setMobileSearchOpen(!mobileSearchOpen)}
                aria-label="search"
              >
                <SearchIcon style={{ color: variables.darkThemeText }} />
              </IconButton>

              {/* Mobile Search Bar */}
              {mobileSearchOpen && (
                <div className={classes.searchBarMobile}>
                  <DynamicAutoSearch
                    open={searchOpen}
                    handleChange={(evt, newVal) => {
                      window.location.href = `/skill-transformation/course-catalogue?category=${newVal.category}`;
                      setMobileSearchOpen(false);
                    }}
                    handleOpen={val => {
                      setSearchOpen(val);
                    }}
                    options={searchCourses}
                    handleSearch={handleGlobalSearch}
                    optLoading={optLoading}
                  />
                </div>
              )}
            </>
          ) : (
            <div className={classes.title}>
              <img
                className={classes.logoAdmin}
                alt="Deviare"
                onClick={() => history.push(Paths.Dashboard)}
                src={logoUrl}
              />
            </div>
          )}

          <div className={classes.headerActions}>
            {userRole === USER_ROLES.USER && (
              <>
                {/* Desktop Menu Items - Dashboard, In-progress, Completed */}
                <div className={classes.rightMenuItem}>
                  {menu_items.map(menuItem => (
                    <Typography
                      key={menuItem.name}
                      component="span"
                      className={`${classes.navSectionLink} ${isNavItemActive(menuItem.path) ? classes.navSectionLinkActive : ''}`}
                      onClick={() => history.push(menuItem.path)}
                      role="link"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          history.push(menuItem.path);
                        }
                      }}
                    >
                      {menuItem.name}
                    </Typography>
                  ))}
                </div>

                {/* Mobile Icons Group - Three Dots and Apps Icon */}
                <div className={classes.mobileIconsGroup}>
                  {/* Mobile Menu Button (Three Dots) */}
                  <IconButton
                    ref={mobileMenuAnchorRef}
                    className={classes.mobileMenuButton}
                    onClick={handleMobileMenuOpen}
                    aria-label="show more menu items"
                    aria-controls={mobileMenuOpen ? 'mobile-menu' : undefined}
                    aria-haspopup="true"
                  >
                    <MoreVertIcon style={{ color: variables.darkThemeText }} />
                  </IconButton>

                  {/* Mobile Explore Icon (Apps) - Next to Three Dots */}
                  {isMobile && (
                    <IconButton
                      ref={menuRef}
                      className={classes.exploreButtonMobile}
                      onClick={handleToggleMenu}
                      aria-label="explore courses"
                      aria-controls={menuOpen ? 'explore-menu' : undefined}
                      aria-haspopup="true"
                    >
                      <AppsIcon style={{ color: variables.darkThemeText }} />
                    </IconButton>
                  )}
                </div>
              </>
            )}
            {!isTinyScreen && (
              <IconButton
                className={classes.iconBtn}
                style={{
                  flex: isMobile ? '1 1 0' : '0 0 auto',
                }}
                aria-label="show notifications">
                <Badge color="secondary">
                  <NotificationsIcon style={{ color: variables.darkThemeText }} />
                </Badge>
              </IconButton>
            )}
            <IconButton
              ref={avatarAnchorRef}
              className={classes.iconBtn}
              aria-label="profile"
              onClick={handleToggle}
              style={{
                padding: isMobile ? 0 : 4,
                flex: isMobile ? '1 1 0' : '0 0 auto',
              }}>
              <Avatar
                alt="Deviare"
                src={
                  profileLoading
                    ? userImg
                    : loggedInUser && loggedInUser.profile_image
                      ? loggedInUser.profile_image
                      : defaultImage
                }
                style={{
                  width: isMobile ? 32 : 40,
                  height: isMobile ? 32 : 40,
                  border: '2px solid rgba(0, 0, 0, 0.08)',
                  transition: 'all 0.2s ease',
                }}
              />
            </IconButton>
            <Button
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              className={classes.profileButton}
              style={{ color: variables.darkThemeText }}
              onClick={handleToggle}
              endIcon={<ExpandMoreIcon style={{ fontSize: 20 }} />}>
              <span className={classes.profileButtonText}>
                {loggedInUser
                  ? `${loggedInUser.firstName} ${loggedInUser.lastName}`
                  : 'Profile'}
              </span>
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <Popper
        open={open}
        anchorEl={isMobile ? avatarAnchorRef.current : anchorRef.current}
        transition
        disablePortal
        placement={isMobile ? "bottom-end" : "bottom"}
        modifiers={{
          offset: {
            enabled: true,
            offset: isMobile ? '0, 8' : '0, 8',
          },
        }}
        style={{ zIndex: 999 }}>
        {({ TransitionProps, placement }) => (
          <Grow
            style={{
              width: '197px',
              backgroundColor: variables.headerColor,
              marginTop: isMobile ? 8 : 34,
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom'
            }}
            {...TransitionProps}>
            <Paper
              style={{
                borderRadius: 12,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                overflow: 'hidden',
              }}>
              <div
                style={{
                  width: '100%',
                  padding: 16,
                  borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
                }}>
                <div
                  style={{ position: 'relative' }}
                  className={classes.profileImg}>
                  <img
                    alt="user logo"
                    width={'80px'}
                    height={'80px'}
                    src={
                      profileLoading
                        ? userImg
                        : loggedInUser && loggedInUser.profile_image
                          ? loggedInUser.profile_image
                          : defaultImage
                    }
                    className={classes.largeImg}
                  />
                  <span className={classes.editBack}>
                    <EditIcon
                      style={{
                        fontSize: 16,
                        fontWeight: 'bold',
                        cursor: 'pointer'
                      }}
                    />
                  </span>
                </div>
              </div>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                  style={{ padding: theme.spacing(1) }}>
                  <MenuItem
                    style={{
                      color: variables.darkThemeText,
                      borderRadius: 8,
                      margin: theme.spacing(0.5, 0),
                      transition: 'all 0.2s ease',
                    }}
                    onClick={handleProfile}>
                    Edit Profile
                  </MenuItem>
                  <MenuItem
                    style={{
                      color: variables.darkThemeText,
                      borderRadius: 8,
                      margin: theme.spacing(0.5, 0),
                      transition: 'all 0.2s ease',
                    }}
                    onClick={handleChangePassword}>
                    Change Password
                  </MenuItem>
                  <MenuItem
                    style={{
                      color: variables.darkThemeText,
                      borderRadius: 8,
                      margin: theme.spacing(0.5, 0),
                      transition: 'all 0.2s ease',
                    }}
                    onClick={handleLogout}>
                    Logout
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {/* Mobile Menu for Dashboard, In-progress, Completed */}
      {userRole === USER_ROLES.USER && (
        <Popper
          open={mobileMenuOpen}
          anchorEl={mobileMenuAnchorRef.current}
          transition
          disablePortal
          style={{ zIndex: 999 }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom'
              }}
              {...TransitionProps}
            >
              <Paper className={classes.mobileMenuPaper}>
                <ClickAwayListener onClickAway={handleMobileMenuClose}>
                  <MenuList
                    autoFocusItem={mobileMenuOpen}
                    id="mobile-menu"
                    style={{ padding: theme.spacing(1) }}
                    onKeyDown={(e) => {
                      if (e.key === 'Tab') {
                        e.preventDefault();
                        handleMobileMenuClose();
                      }
                    }}
                  >
                    {menu_items.map((menuItem) => (
                      <MenuItem
                        key={menuItem.name}
                        onClick={() => handleMobileMenuItemClick(menuItem.path)}
                        className={`${classes.mobileNavMenuItem} ${isNavItemActive(menuItem.path) ? classes.mobileNavMenuItemActive : ''}`}
                        style={{
                          color: isNavItemActive(menuItem.path) ? '#3C7DDD' : variables.darkThemeText,
                        }}
                      >
                        {menuItem.name}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}

      {userRole === USER_ROLES.USER && (
        <Popper
          open={menuOpen}
          anchorEl={menuRef.current}
          transition
          disablePortal={!isMobile}
          placement={isMobile ? "bottom-end" : "bottom-start"}
          modifiers={{
            offset: {
              enabled: true,
              offset: '0, 8',
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'viewport',
            },
          }}
          style={{ zIndex: 1300, width: '100%', position: 'relative' }}>
          {({ TransitionProps, placement }) => (
            <Grow
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom'
              }}
              {...TransitionProps}>
              <Paper
                style={{
                  width: isMobile ? '95vw' : '99%',
                  maxWidth: isMobile ? '90vw' : 'none',
                  backgroundColor: variables.headerColor,
                  marginTop: 8,
                  padding: isMobile ? theme.spacing(2.5) : theme.spacing(4),
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                  borderRadius: 12,
                  maxHeight: isMobile ? '80vh' : '85vh',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                }}>
                <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                  <div className={classes.menuContainer}>
                    {courseCatalogueList.slice(0, isMobile ? 4 : 8).map(courseItem => (
                      <div key={courseItem.category} className={classes.menuContainerItem}>
                        <Typography variant="h3" className={classes.header}>
                          {courseItem.category}
                        </Typography>
                        <div className={classes.menuSubContainer}>
                          {(courseItem.courses || []).slice(0, isMobile ? 3 : 4).map((item, idx) => (
                            <Button
                              key={idx}
                              style={{
                                color: variables.darkThemeText,
                                cursor: 'pointer',
                                fontSize: isMobile ? '0.75rem' : '0.875rem',
                                padding: isMobile ? '6px 12px' : '8px 16px',
                                textAlign: 'left',
                                justifyContent: 'flex-start',
                                textTransform: 'none',
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                                minHeight: 'auto',
                                lineHeight: 1.5,
                                borderRadius: 8,
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  backgroundColor: 'rgba(60, 125, 221, 0.08)',
                                },
                              }}
                              onClick={() => handleSubManuClicked(item)}>
                              {isMobile
                                ? (item.name.length <= 30
                                  ? item.name
                                  : item.name.substring(0, 30).concat('...'))
                                : (item.name.length <= 35
                                  ? item.name
                                  : item.name.substring(0, 35).concat('...'))}
                            </Button>
                          ))}
                          {(courseItem.courses || []).length > 4 && (
                            <Button
                              className={classes.viewAll}
                              onClick={() => handleSubManuClicked(courseItem)}>
                              View All
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}

                    <div className={classes.lastRow}>
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{ padding: '10px 45px', borderRadius: 10 }}
                        className={classes.browseAll}
                        onClick={() => handleSubManuClicked()}>
                        Browse All Courses
                      </Button>
                    </div>
                  </div>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </div>
  );
};

export default Header;
